import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import GlobalStyle from "./shared/GlobalStyle";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { isDevice, offlineEnabled } from "./tenant";

ReactDOM.render(
  <React.StrictMode>
    <GlobalStyle />
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Offline: the service worker (src/service-worker.js) serves the app shell,
// the tenant API answers and the media it cached; a Magic Folio box keeps the
// whole tenant cached (src/sync.js) and reloads onto a new build as soon as
// one is installed. Opt-in (tenant.js offlineEnabled): only a box, or a
// browser with the test flag, gets the worker and the persistent-storage
// request — today's visitors keep the plain site, nothing cached, no prompt.
if (offlineEnabled()) {
  serviceWorkerRegistration.register({
    onUpdate: () => {
      if (isDevice()) setTimeout(() => window.location.reload(), 2000);
    },
  });
  if (navigator.storage && navigator.storage.persist) {
    navigator.storage.persist().catch(() => {});
  }
} else {
  // a browser that once opted in and no longer does drops the worker
  serviceWorkerRegistration.unregister();
}
